import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { usePosting, useTitle } from '../../Hooks';
import { Payout, SetLoading } from '../../Classes';
import { Header, Stat, Message, Button, Table, Toast } from 'react-frontier';
import { Card, Modal } from '../../components';
import { addCommas, bindClick } from '@tempu/components/Util';
import BusinessAccess from '../../BusinessAccess';
import API from '../../API';
import moment from 'moment';
import classNames from 'classnames';

interface PostingPayoutProps{
	
}

var PostingPayout = (props: PostingPayoutProps)=>{
	var params = useParams<{ bid: string, pid: string }>();
	var posting_id = parseInt(params?.pid);
	var [loadError, setLoadError] = useState<string>(null);
	var [postingPayouts, setPostingPayouts] = useState<Payout[]>(null);
	var [newPayoutModal, setNewPayoutModal] = useState<boolean>(false);
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [newPayoutInfo, setNewPayoutInfo] = useState<{ workers: number, total: number}>(null);
	var navigate = useNavigate();

	var { setTitle, setAction } = useTitle();
	var { hasAccess } = usePosting(posting_id);

	useEffect(()=>{
		setTitle('Liquidaciones')
		if(!posting_id || Number.isNaN(posting_id)) return;
		if(!hasAccess(BusinessAccess.ACCOUNTING.VIEW_PAYOUTS)) return;

		if(hasAccess(BusinessAccess.ACCOUNTING.CREATE_PAYOUTS)){
			setAction(
				<Button text='Nueva liquidación' iconName='plus-circle' color='black' onClick={getPayoutInfo}/>
			);
		}

		API.getPostingPayouts(posting_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setPostingPayouts(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error inesperado cargando las liquidaciones del empleo. (LCL-1)');
		})
	}, []);

	var createPayout = async(setLoading: SetLoading)=>{
		setLoading(true);
		API.createPostingPayout(posting_id).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Liquidación generada!');

			return navigate(`/business/${params.bid}/posting/${posting_id}/payout/${res.data.payout_id}`);
		}).catch(err=>{
			setModalPrompts(['Hubo un error al generar la liquidación. (PCE-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	}

	var getPayoutInfo = async(setLoading: SetLoading)=>{
		setLoading(true);
		API.getPostingPayoutPreparation(posting_id).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			setNewPayoutInfo(res.data);
			return setNewPayoutModal(true);
		}).catch(err=>{
			setModalPrompts(['Hubo un error al obtener los datos de liquidación. (PCE-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	}

	if(!hasAccess(BusinessAccess.ACCOUNTING.VIEW_PAYOUTS)){
		return <Header text='Sin acceso' subtext='No tienes acceso a esta página' />
	}

	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}

	if(!postingPayouts){
		return <Header loading text='Cargando datos' />;
	}
	
	var currentDebt = postingPayouts?.reduce((s, p) => { return s + p.total_pending; }, 0);

	return <div className="tp posting-payouts-screen">
		<Stat.Group>
			<Stat value={'$'+addCommas(currentDebt)} label={'Pendiente de pago'} />
			<Stat value={postingPayouts.length} label={'Liquidaciónes'} />
		</Stat.Group>
		{postingPayouts.length>0 && (
			<Header text='Liquidaciones' centered={false} style={{ marginTop: 15 }} size='small' />
		)}
		{postingPayouts.length !== 0 ? (
			postingPayouts.map(p=>(
				<Card className='payout' key={`LQPLH-${p.payout_id}`} as={Link} to={`/business/${params.bid}/posting/${posting_id}/payout/${p.payout_id}`}>
					<div className="left">
						<div className="value">Liquidación: {p.payout_id}</div>
						<div className="meta id">{moment.unix(p.date_created).format('DD/MMM/YY HH:mm')}</div>
						<div className="value">{p.employees} empleados</div>
					</div>
					<div className='right'>
						<div className="amount">${addCommas(p.total_paid + p.total_paid)}</div>
						{p.total_paid > 0 && !p.paid && <div className="second">Pagado: ${addCommas(p.total_paid)}</div>}
						<div style={{ marginTop: 5 }} className={classNames("fr label", {
							green: p.paid && !p.cancelled,
							yellow: !p.paid && !p.cancelled,
							red: p.cancelled
						})}>
							{p.cancelled ? 'Cancelada' : p.paid ? 'Pagada' : 'No Pagada'}
						</div>
					</div>
				</Card>
			))
		) : (
			<Header text={'Sin liquidaciones'} subtext={'Este empleo no tiene liquidaciones'} iconName='money-check-dollar' style={{ marginTop: 15 }} />
		)}
		{hasAccess(BusinessAccess.ACCOUNTING.CREATE_PAYOUTS) && <Modal open={newPayoutModal} onClose={bindClick(setNewPayoutModal, false)} size='tiny'>
			<Modal.Header>Generar liquidación</Modal.Header>
				{newPayoutInfo &&<Modal.Content>
					<Header text='¿Generar liquidación?'/>
					<Table 
						details
						title='Información de liquidación'
						data={[
							['Empleados', newPayoutInfo.workers],
							['Total a pagar', '$'+ addCommas(newPayoutInfo.total)]
						]}
						style={{ marginBottom: 15, marginTop: 15 }}
					/>
					<Message type='warning' centered>
						Estas seguro de generar una nueva liquidación de este empleo?
					</Message>
					<Message list={modalPrompts} type='error' />
				</Modal.Content>}
			<Modal.Actions>
				<Button text='Cancelar' basic onClick={bindClick(setNewPayoutModal)} />
				<Button text='Crear' color='black' onClick={createPayout}/>
			</Modal.Actions>
		</Modal>}
	</div>
}

export default PostingPayout;